class BrandDirectory extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-brand-search]');
    this.cards = [...this.querySelectorAll('[data-brand-card]')];
    this.buttons = [...this.querySelectorAll('[data-brand-letter-button]')];
    this.empty = this.querySelector('[data-brand-empty]');
    this.status = this.querySelector('[data-brand-status]');
    this.activeLetter = '*';

    const availableLetters = new Set(this.cards.map((card) => card.dataset.brandLetter));
    this.buttons.forEach((button) => {
      const letter = button.dataset.brandLetterButton;
      if (letter !== '*' && !availableLetters.has(letter)) button.disabled = true;
      button.addEventListener('click', () => {
        this.activeLetter = letter;
        this.buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.filter();
      });
    });

    this.input?.addEventListener('input', () => this.filter());
    this.filter();
  }

  filter() {
    const query = (this.input?.value || '').trim().toLocaleLowerCase();
    let visible = 0;
    this.cards.forEach((card) => {
      const matchesText = !query || card.dataset.brandSearch.includes(query);
      const matchesLetter = this.activeLetter === '*' || card.dataset.brandLetter === this.activeLetter;
      card.hidden = !(matchesText && matchesLetter);
      if (!card.hidden) visible += 1;
    });

    if (this.empty) this.empty.hidden = visible !== 0;
    if (this.status) this.status.textContent = this.dataset.resultsLabel.replace('[count]', String(visible));
  }
}

if (!customElements.get('brand-directory')) customElements.define('brand-directory', BrandDirectory);
